<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ 'billing.waitingTimes.title' | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="creation-form">
      <button *ngIf="!isCreationMode" (click)="onEdit()" [matTooltip]="'billing.waitingTimes.add' | translate"
        mat-mini-fab class="action-button" color="primary">
        <mat-icon aria-label="Add">add</mat-icon>
      </button>
      <app-waiting-time-edit *ngIf="isCreationMode && !editedId" (editFinished)="onEditFinished()"
        [sitesAlreadyTaken]="sitesAlreadyTaken"></app-waiting-time-edit>
    </section>

    <mat-form-field class="filterField">
      <mat-label>Filtrer</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Votre filtre" #input>
    </mat-form-field>

    <section class="datatable-waitingTimes">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="site">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'billing.waitingTimes.list.site' | translate }}
          </th>
          <td mat-cell *matCellDef="let waitingTime"> {{ waitingTime.site.name }} </td>
        </ng-container>

        <ng-container matColumnDef="minutes">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'billing.waitingTimes.list.minutes' | translate }}
          </th>
          <td mat-cell *matCellDef="let waitingTime"> {{ waitingTime.minutes }} </td>
        </ng-container>

        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'billing.waitingTimes.list.price' | translate }}
          </th>
          <td mat-cell *matCellDef="let waitingTime"> {{ waitingTime.price }} </td>
        </ng-container>

        <ng-container matColumnDef="nonHourlyPrice">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'billing.waitingTimes.list.nonHourlyPrice' |
            translate }}
          </th>
          <td mat-cell *matCellDef="let waitingTime"> {{ waitingTime.nonHourlyPrice }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> {{ 'billing.waitingTimes.list.actions' | translate }} </th>
          <td mat-cell *matCellDef="let waitingTime">
            <ng-container *ngIf="waitingTime.id !== editedId">
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'billing.waitingTimes.list.edit' | translate" (click)="onEdit(waitingTime.id)">
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let waitingTime" [attr.colspan]="displayedColumns.length">
            <div *ngIf="waitingTime.id === editedId" class="row-edit"
              [@detailExpand]="waitingTime.id === editedId ? 'expanded' : 'collapsed'">
              <app-waiting-time-edit [waitingTime]="waitingTime" (editFinished)="onEditFinished()"
                [sitesAlreadyTaken]="sitesAlreadyTaken"></app-waiting-time-edit>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"
          [ngClass]="{ 'expanded-row': row.id === editedId }"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[20, 25, 50, 100]" showFirstLastButtons [length]="waitingTimes.length"
        class="paginator"></mat-paginator>
    </section>

    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
  </mat-card-content>
</mat-card>